module.exports = __webpack_public_path__ + "img/symbol_9.cea8b1ec.png";